export default __webpack_public_path__ + "static/about-us-support-2-2e86799d127f74f7197027b740f92baf.png";